module.exports = __webpack_public_path__ + "img/logo_jp.e2dad420.png";